import React, { FC } from 'react';
import FormControlBar from 'Components/WelcomeSlides/FormControlBar';
import CompanyForm, { ICompanyFormValues } from './CompanyForm';
import { useMutation, useQuery } from '@apollo/client';
import { GET_COMPANY_DETAILS } from 'graphql/secure/queries';
import { useLogEvent } from 'hooks/useLogEvent';
import useMessages from 'hooks/useMessages';
import Loader from 'Components/Forms/Loader';
import { UPDATE_COMPANY } from 'graphql/secure/mutations/company.mutations';
import ErrorState from 'Components/ErrorState';

interface ICompanyProps {
  active: boolean;
}

const Company: FC<ICompanyProps> = ({ active }) => {
  const { logEvent } = useLogEvent();
  const {
    data: { company } = {},
    error,
    loading,
  } = useQuery(GET_COMPANY_DETAILS, {
    fetchPolicy: 'cache-only',
  });

  const { setSuccessMessage, setErrorMessage } = useMessages();
  const [updateCompany] = useMutation(UPDATE_COMPANY, {
    onCompleted: () => {
      setSuccessMessage('Success! Company details were updated.');
      logEvent('WELCOME_SLIDES_UPDATE_COMPANY');
    },
    onError: () => {
      setErrorMessage('Something went wrong updating your companies details.');
    },
  });

  const handleSubmit = (input: ICompanyFormValues) => {
    return updateCompany({
      variables: {
        input,
      },
    });
  };

  if (error) return <ErrorState error={error} />;
  if (!company && loading) return <Loader />;

  return (
    <>
      <CompanyForm company={company} onSubmit={handleSubmit} active={active}>
        {({ submitForm, isSubmitting }) => (
          <FormControlBar onSubmit={submitForm} isSubmitting={isSubmitting} />
        )}
      </CompanyForm>
    </>
  );
};
export default Company;
